import $ from 'cash-dom';
import svg4everybody from 'svg4everybody';
import inpageScroll from './components/inpageScroll';
import initSwiper from './components/swiper';
import initHeader from './components/header';
import initBoxes from './components/boxes';
import initPricing from './components/pricing';
import featuresList from './components/featuresList';

svg4everybody();

$(document).ready(() => {
  initHeader();
  initSwiper();
  inpageScroll();
  initBoxes();
  initPricing();
  featuresList();
});
